import { firestore } from "../firebase";
import { hasValidStoreHours } from "../utils/storeHours";

const normalizeBranchCode = (value) => String(value || "").trim().toUpperCase();

/** Reads the current Firestore hours independently of the menu API. */
export async function fetchBranchHours(branchCode) {
  const normalizedCode = normalizeBranchCode(branchCode);
  if (!normalizedCode) return null;

  const snapshot = await firestore
    .collection("branches")
    .where("branchCode", "==", normalizedCode)
    .limit(1)
    .get();

  if (snapshot.empty) return null;
  const branch = snapshot.docs[0].data() || {};
  const startTime = typeof branch.startTime === "string" ? branch.startTime.trim() : "";
  const endTime = typeof branch.endTime === "string" ? branch.endTime.trim() : "";

  return hasValidStoreHours(startTime, endTime) ? { startTime, endTime } : null;
}
